import AddVehicleInfoGroupModal from './add-vehicle-info-group-modal.vue'
export default AddVehicleInfoGroupModal
